import { DialogContentText, DialogContent } from '@mui/material';
import { DateTime } from 'luxon';
import { type FC, useCallback, useMemo } from 'react';

import { useMutateDeleteLog } from '../../api/index.js';
import { type Log } from '../../models/index.js';
import { capitalize } from '../../utils/index.js';
import DeleteDialog from '../DeleteDialog.js';

interface LogDeleteProps {
  open: boolean;
  onClose: () => void;
  log?: Log;
  refetch: () => void;
  timezone?: string;
}

const LogDelete: FC<LogDeleteProps> = ({ open, onClose, log, refetch, timezone }) => {
  const deleteMutation = useMutateDeleteLog();

  const onSubmit = useCallback(async () => {
    if (log?.id) {
      return deleteMutation.mutateAsync(log.id);
    }
  }, [log, deleteMutation]);

  const dateTime = useMemo(() => {
    if (log?.createdAt) {
      return DateTime.fromISO(log.createdAt, { zone: timezone });
    }
    return '';
  }, [log, timezone]);

  return (
    <DeleteDialog
      open={open}
      name={'log'}
      onClose={onClose}
      onSubmit={onSubmit}
      refetch={refetch}
    >
      {log ? (
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dateTime ? `${dateTime.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)}
            ${dateTime.toLocaleString(DateTime.TIME_24_WITH_SECONDS)}` : ''}
            <br />
            {capitalize(log?.code.code)} {capitalize(log.code.description)}
          </DialogContentText>
        </DialogContent>
      ) : null}
    </DeleteDialog>
  );
};

export default LogDelete;
